module.exports = __webpack_public_path__ + "media/images/google-logo-0590aaf0fe36e23dcc8c7ecca9e74cbb.png";